const galleryId = 104;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = [

];
group.forEach((i) => addItemToGroup(i, 'TAG'));

group = ["sh_100424281.jpg","sh_1233658981.jpg","sh_763407490.jpg","sh_655853674a.jpg","sh_660386209a.jpg","sh_1244391772a.jpg","sh_417791032a.jpg","sh_1751269484a.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Tooth anatomy'));

export default items;
